export default {"src":"/_next/static/media/white-entry-point.6cb7d24f.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};